import { render, staticRenderFns } from "./ModalExcluirReajuste.vue?vue&type=template&id=1f83a254"
import script from "./ModalExcluirReajuste.vue?vue&type=script&lang=js"
export * from "./ModalExcluirReajuste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports